let personalizationAdded = false;
let initialBasePrice = null;
let initialBuyButtonText = null;  // ← new

function togglePersonalize() {
  const section = document.getElementById("engravingFields");
  const isNowVisible = section.style.display === "none";
  section.style.display = isNowVisible ? "block" : "none";

  if (isNowVisible && !personalizationAdded) {
    personalizationAdded = true;
    updatePrice();
  }
}

function changeQty(delta) {
  const qtyInput = document.getElementById('quantity');
  let current = parseInt(qtyInput.value);
  qtyInput.value = Math.max(1, (isNaN(current) ? 1 : current + delta));
  updatePrice();
}

function updatePrice() {
  const qty = parseInt(document.getElementById('quantity').value, 10) || 1;
  const baseEl = document.getElementById('basePrice');
  const priceEl = document.getElementById('dynamicPrice');

  // parseFloat so decimals stick
  const basePriceNumber = parseFloat(
    baseEl.innerText.replace(/[^\d.]/g, '')
  ) || 0;

  const total = basePriceNumber * qty;
  priceEl.innerText = `$${total.toFixed(2)}`;
}

document.addEventListener('DOMContentLoaded', function () {
  const buyButton = document.getElementById('custom-buy-button');
  const wrapper   = document.querySelector('.product-wrapper');
  const productId = wrapper?.getAttribute('data-bnx-product-id');

  // Capture initial text so we can reset to it later
  if (buyButton) {
    initialBuyButtonText = buyButton.textContent.trim();
  }

  if (buyButton && productId) {
    buyButton.addEventListener('click', function () {
      const btn = this;
      const qty  = parseInt(document.getElementById('quantity').value, 10) || 1;
      const line1 = document.getElementById('line1')?.value.trim();
      const line2 = document.getElementById('line2')?.value.trim();
      const line3 = document.getElementById('line3')?.value.trim();
      const engraving = [line1, line2, line3].filter(Boolean).join('\n') || null;

      // Step 1: show intermediate states
      btn.textContent = 'Adding...';
      setTimeout(() => btn.textContent = 'Added', 500);

      // Step 2: after a short delay, reset to the original label
      setTimeout(() => {
        btn.textContent = initialBuyButtonText;
      }, 1500);

      // Step 3: fire Bottle Nexus addToCart
      if (window.bottlenexus?.addToCart) {
        window.bottlenexus.addToCart(
          parseInt(productId, 10),
          "71d16ff6-6853-11ee-981a-0242ac110002",
          {
            quantity: qty,
            recurrence: 'one-time',
            donation: 'enforce',
            engravingLines: engraving
          }
        );
      }
    });
  }

  // Give Bottle Nexus a moment to inject the base price before we snapshot it
  setTimeout(() => {
    const baseEl = document.getElementById('basePrice');
    if (baseEl) {
      initialBasePrice = parseFloat(
        baseEl.innerText.replace(/[^\d.]/g, '')
      ) || 0;
    }
    updatePrice();
  }, 700);
});